import React, { Component } from 'react';

class Header extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        let props = this.props;
        let denominacion = props.data.vistaCliente.client.RazonSocial;
        let administradora = props.data.vistaCliente.GET_ADMINISTRADORA[0].Descripcion;
        let descripcionEmpresa = props.data.descripcionEmpresa + " (" + props.data.empresa.Descripcion + ")";

        return (
            <div className="row bottom-separator-xs">
                <div className="col-md-9">
                    <label className="label-primary">{denominacion}   ❯   {administradora}   ❯   {descripcionEmpresa}</label>
                </div>

                {/* ICONO DE EXPORTAR, IMPRIMIR Y ELIMINAR
                <div className="col-xs-1">
                    <span className="glyphicon glyphicon-file" aria-hidden="true"></span>
                </div>
                    <div className="col-xs-1">
                        <span className="glyphicon glyphicon-print" aria-hidden="true"></span>
                    </div>
                    <div className="col-xs-1">
                        <span className="glyphicon glyphicon-trash" aria-hidden="true"></span>
                    </div>*/}
            </div>
        );
    }

};
export default Header;